import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from "../shared/services/service";
import { Funcoes } from "../funcoes";

@Injectable()
export class ResponsaveisTecnicosService extends Service {

  protected url: string = this.dominio + "/adm/laudos-cd/responsaveis-tecnicos/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos.service.ts